export const businessAreaConstants = {
  API_INSERT: '/api/business_area/insert',
  API_UPDATE: '/api/business_area/update',
  API_DELETE: '/api/business_area/delete',
  API_GET: '/api/business_area/',
  API_GETALL: '/api/business_area/getall',

  INSERT_REQUEST: 'BUSINESS_AREA_INSERT_REQUEST',
  INSERT_SUCCESS: 'BUSINESS_AREA_INSERT_SUCCESS',
  INSERT_FAILURE: 'BUSINESS_AREA_INSERT_FAILURE',

  UPDATE_REQUEST: 'BUSINESS_AREA_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'BUSINESS_AREA_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'BUSINESS_AREA_UPDATE_FAILURE',

  DELETE_REQUEST: 'BUSINESS_AREA_DELETE_REQUEST',
  DELETE_SUCCESS: 'BUSINESS_AREA_DELETE_SUCCESS',
  DELETE_FAILURE: 'BUSINESS_AREA_DELETE_FAILURE',

  GET_REQUEST: 'BUSINESS_AREA_GET_REQUEST',
  GET_SUCCESS: 'BUSINESS_AREA_GET_SUCCESS',
  GET_FAILURE: 'BUSINESS_AREA_GET_FAILURE',

  GETALL_REQUEST: 'BUSINESS_AREA_GETALL_REQUEST',
  GETALL_SUCCESS: 'BUSINESS_AREA_GETALL_SUCCESS',
  GETALL_FAILURE: 'BUSINESS_AREA_GETALL_FAILURE',

  RESET: 'BUSINESS_AREA_RESET',
  SERVICE: 'BUSINESS_AREA_SERVICE',
};
